import Icon from '../Icon';
import IconButton from '../IconButton';
import cx from '../cx';

const ICON_BY_KIND = { success: 'success-circle', error: 'error-circle', info: 'info' };

// Presentational toast pill, tinted by kind (info blue, success green,
// error red) in the top-center layer. `bumped` plays a short pulse instead
// of the slide-in when the provider refreshes an identical toast.
export default function Toast({ kind, message, bumped, onDismiss, dismissLabel }) {
  return (
    <div className={cx('toast', `toast--${kind}`, bumped && 'toast--bump')}>
      <span className="toast__icon"><Icon name={ICON_BY_KIND[kind]} size={14} /></span>
      <span>{message}</span>
      <IconButton label={dismissLabel} size="sm" className="toast__dismiss" onClick={onDismiss}>
        <Icon name="close" size={12} />
      </IconButton>
    </div>
  );
}
